import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-placeholder-no-data',
  templateUrl: './placeholder-no-data.component.html',
  styleUrls: ['./placeholder-no-data.component.scss']
})
export class PlaceholderNoDataComponent {

}
